import React, { useCallback, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import './classifications.scss';
import {
  Calculators,
  DefaultBlot,
  EllipseImage,
  GraphLineUp,
  LightEllipse,
  LineFilled,
  LineHalfFilled,
  LineUnfilled,
  Lmaps,
} from 'src/assets';

import { ReactComponent as GrayCircle } from 'src/assets/pages/instruments/GrayCircle.svg';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const Classifications = () => {
  const { t } = useTranslation();

  const [selectedTab, setSelectedTab] = useState('graph');

  const onTabClick = useCallback(
    (tab) => () => {
      setSelectedTab(tab);
    },
    [],
  );

  const options = {
    graph: {
      image: GraphLineUp,
      title: `classifications:graph:title`,
      subtitle: `classifications:${selectedTab}:subtitle`,
      list: [
        {
          title: `classifications:${selectedTab}:title_1`,
        },
        {
          title: `classifications:${selectedTab}:title_2`,
        },
        {
          title: `classifications:${selectedTab}:title_3`,
        },
      ],
    },
    indicator: {
      image: Lmaps,
      title: `classifications:indicator:title`,
      subtitle: `classifications:${selectedTab}:subtitle`,
      list: [
        {
          title: `classifications:${selectedTab}:title_1`,
        },
        {
          title: `classifications:${selectedTab}:title_2`,
        },
        {
          title: `classifications:${selectedTab}:title_3`,
        },
      ],
    },
    order: {
      image: Calculators,
      title: `classifications:order:title`,
      subtitle: `classifications:${selectedTab}:subtitle`,
      list: [
        {
          title: `classifications:${selectedTab}:title_1`,
        },
        {
          title: `classifications:${selectedTab}:title_2`,
        },
        {
          title: `classifications:${selectedTab}:title_3`,
        },
        {
          title: `classifications:${selectedTab}:title_4`,
        },
        {
          title: `classifications:${selectedTab}:title_5`,
        },
      ],
    },
  };

  const isActiveIndicator = selectedTab === 'indicator' || selectedTab === 'order';

  const normalizeLineFill = useCallback(() => {
    if (selectedTab === 'indicator') {
      return LineHalfFilled;
    }
    if (selectedTab === 'order') {
      return LineFilled;
    }

    return LineUnfilled;
  }, [selectedTab]);

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="classifications">
      <div className={`classifications-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="classifications-title">
          <supertitle>{t('mainRecomendations:supertitle')}</supertitle>
          <h1>
            <blue-underline>{t('mainRecomendations:hint')}</blue-underline>{' '}
            <blue-text>{t('mainRecomendations:manage')}</blue-text> {t('mainRecomendations:risk')}
          </h1>
          <text>{t('mainRecomendations:subtitle')}</text>
        </div>

        <div className="classifications-section">
          <div className="classifications-tab">
            <div
              className={`classifications-tab-item tab-large tab-active`}
              onClick={onTabClick('graph')}
            >
              <GrayCircle />
              <h3>{t(options.graph.title)}</h3>
            </div>
            <div className="classifications-tab-image">
              <img
                src={selectedTab === 'graph' ? LineHalfFilled : LineFilled}
                alt={selectedTab === 'graph' ? LineHalfFilled : LineFilled}
              />
            </div>
            <div
              className={`classifications-tab-item tab-small ${
                isActiveIndicator ? 'tab-active' : ''
              }`}
              onClick={onTabClick('indicator')}
            >
              <GrayCircle />
              <h3>{t(options.indicator.title)}</h3>
            </div>
            <div className="classifications-tab-image">
              <img src={normalizeLineFill()} alt={normalizeLineFill()} />
            </div>
            <div
              className={`classifications-tab-item tab-small ${
                selectedTab === 'order' ? 'tab-active' : ''
              }`}
              onClick={onTabClick('order')}
            >
              <GrayCircle />
              <h3>{t(options.order.title)}</h3>
            </div>
          </div>
          <div className="classifications-tab-content">
            <img src={options[selectedTab].image} alt={options[selectedTab].image} />
            <div className="classifications-tab-box">
              <div className="financial-tab-box">{t(options[selectedTab].subtitle)}</div>
              <ul>
                {options[selectedTab].list.map((item, index) => (
                  <li key={index}>
                    <text>
                      <Trans i18nKey={item.title} />
                    </text>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <img src={LightEllipse} alt={LightEllipse} className="classifications-image-1" />
        <img src={EllipseImage} alt={EllipseImage} className="classifications-image-2" />
        <img src={EllipseImage} alt={EllipseImage} className="classifications-image-3" />
        <img src={DefaultBlot} alt={DefaultBlot} className="classifications-image-4" />
      </div>
    </div>
  );
};
